var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7833 17.6345C18.2779 16.3621 17.4146 14.5022 17.4146 12.5317V9.7558C17.4146 6.25205 14.812 3.35167 11.4406 2.86578V1.79046C11.4406 1.23986 10.9946 0.794792 10.445 0.794792C9.89535 0.794792 9.44929 1.23986 9.44929 1.79046V2.86578C6.07696 3.35167 3.47528 6.25205 3.47528 9.7558V12.5317C3.47528 14.5022 2.61204 16.3621 1.09763 17.6425C0.710315 17.974 0.488281 18.4559 0.488281 18.9657C0.488281 19.9265 1.26988 20.7081 2.2307 20.7081H18.6592C19.62 20.7081 20.4016 19.9265 20.4016 18.9657C20.4016 18.4559 20.1796 17.974 19.7833 17.6345Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4467 25.6C12.2498 25.6 13.7582 24.3146 14.1047 22.613H6.78857C7.13507 24.3146 8.6435 25.6 10.4467 25.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.354c34a776e2e627f540d1903b427090.svg";
export { ForwardRef as ReactComponent };